import wordmarkSrc from '@/assets/branding/wordmark.png';

export default function LandingFooter() {
  return (
    <footer
      className="py-10"
      style={{ borderTop: '1px solid var(--color-border-subtle)' }}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex flex-col items-center gap-6 sm:flex-row sm:justify-between">
          {/* Left — wordmark + copyright */}
          <div className="flex items-center gap-3">
            <img
              src={wordmarkSrc /* dark-only */}
              alt="PointeTracer"
              className="h-5 w-auto object-contain opacity-60"
            />
            <span
              className="text-body-sm"
              style={{ color: 'var(--color-text-muted)' }}
            >
              &copy; 2026 PointeTracer
            </span>
          </div>

          {/* Right — links */}
          <nav
            className="flex items-center gap-6"
            aria-label="Footer navigation"
          >
            <a
              href="mailto:hello@pointetracer.com"
              className="text-body-sm transition-colors duration-150"
              style={{ color: 'var(--color-text-muted)' }}
              onMouseEnter={(e) =>
                ((e.currentTarget as HTMLAnchorElement).style.color =
                  'var(--color-text-secondary)')
              }
              onMouseLeave={(e) =>
                ((e.currentTarget as HTMLAnchorElement).style.color =
                  'var(--color-text-muted)')
              }
            >
              Contact
            </a>
            <a
              href="#"
              className="text-body-sm transition-colors duration-150"
              style={{ color: 'var(--color-text-muted)' }}
              onMouseEnter={(e) =>
                ((e.currentTarget as HTMLAnchorElement).style.color =
                  'var(--color-text-secondary)')
              }
              onMouseLeave={(e) =>
                ((e.currentTarget as HTMLAnchorElement).style.color =
                  'var(--color-text-muted)')
              }
            >
              Privacy
            </a>
            <a
              href="#"
              className="text-body-sm transition-colors duration-150"
              style={{ color: 'var(--color-text-muted)' }}
              onMouseEnter={(e) =>
                ((e.currentTarget as HTMLAnchorElement).style.color =
                  'var(--color-text-secondary)')
              }
              onMouseLeave={(e) =>
                ((e.currentTarget as HTMLAnchorElement).style.color =
                  'var(--color-text-muted)')
              }
            >
              Terms
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
